import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["textarea", "parseError"];

  syncBeforeSubmit(event) {
    const form   = event.target;
    const hidden = form.querySelector('input[name="json_content"]');
    if (hidden) {
      hidden.value = this.textareaTarget.value;
    }
  }

  formatJson() {
    try {
      const parsed = JSON.parse(this.textareaTarget.value);
      this.textareaTarget.value = JSON.stringify(parsed, null, 2);
      this.hideParseError();
    } catch (e) {
      this.showParseError('Invalid JSON: ' + e.message);
    }
  }

  hideParseError() {
    if (!this.hasParseErrorTarget) {
      return;
    }

    this.parseErrorTarget.classList.add('d-none');
    this.parseErrorTarget.textContent = '';
  }

  showParseError(message) {
    if (!this.hasParseErrorTarget) {
      return;
    }

    this.parseErrorTarget.classList.remove('d-none');
    this.parseErrorTarget.textContent = message;
  }
}
